import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth';
import uploadTracker from './modules/uploadTracker';
import layout from './modules/layout';

Vue.use(Vuex)

// var state = {
//   user: [],
//   uploadTracker: {},

// }

// var getters = {

// }

// var actions = {

// }

// var mutations = {

// }


function objEmpty(obj) {
  for (let k in obj) {
    if (hasOwnProperty.call(obj, k)) {
      return false;
    }
  }
  return true;
}

var modules = {
  auth,
  uploadTracker,
  layout
}

export default new Vuex.Store({
  state: {

    appActive: true,
    uploadSvcActive: true,
    contactActive: true,
    errorMsg: '',
    docListeners: {},

    // Route-related properties
    loginRdq: '', // login redirect query, i.e. the value of 'redirect' on /login path
    pageAccess: '',
    justLoggedIn: false,

    appIsReady: false, // may or may not use this

    uploadProgress: 0, // percentage progress of file upload, i.e. JUST the uploading of the file, NOT the entire upload process 
    uploadStatus: '', // result of upload, sent from server
    uploadInProgress: false, // Set to true when new upload initiated; set to false when ALL ops (including async ops) are completed 
    uploadCompleted: false, // Applies to ENTIRE upload file process; if error and process ends early or goes to completion, will be true
    numUploadTrackerChanges: 0, // Number of upload tracker doc changes; tracked/incremented by uploadTracker doc listener function in stateUtils.js 



    breeds: {},

    userProfile: {},
    userEnabled: true

  },
  getters: {
    appActive(state) {
      return state.appActive;
    },
    uploadSvcActive(state) {
      return state.uploadSvcActive;
    },
    contactActive(state) {
      return state.contactActive;
    },

    uploadInProgress(state) {
      return state.uploadInProgress;
    },
    uploadCompleted(state) {
      return state.uploadCompleted;
    },
    numUploadTrackerChanges(state) {
      return state.numUploadTrackerChanges;
    },
    errorMsg(state) {
      return state.errorMsg;
    },
    // lastAction(state) {
    //   return state.lastAction;
    // },
    docListeners(state) {
      return state.docListeners;
    },

    uploadProgress(state) {
      return state.uploadProgress;
    },

    userProfile(state) {
      return objEmpty(state.userProfile) ? null : state.userProfile;
    },

    userEnabled(state) {
      return state.userEnabled;
    },

    // testing here ... may or may not keep -- if keep, gotta use it.
    appReady(state) {
      // return state.appIsReady
      return !!state.auth.user && !objEmpty(state.uploadTracker.imageCounts)
    },


  },
  actions: {
    setAppActive({ commit }, boolVal) {
      commit('setAppActive', boolVal);
    },
    setUploadSvcActive({ commit }, boolVal) {
      commit('setUploadSvcActive', boolVal);
    },
    setContactActive({ commit }, boolVal) {
      commit('setContactActive', boolVal);
    },
    // Increment number of upload tracker changes 
    incNumUploadTrackerChanges({
      commit
    }) {
      commit('incNumUploadTrackerChanges')
    },
    // Set number of upload tracker changes to zero (0) 
    resetNumUploadTrackerChanges({
      commit
    }) {
      commit('resetNumUploadTrackerChanges')
    },
    setUploadInProgress({
      commit
    }, boolVal) {
      commit('setUploadInProgress', boolVal);
    },
    setUploadCompleted({
      commit
    }, boolVal) {
      commit('setUploadCompleted', boolVal);
    },

    setBreeds({
      commit
    }, objBreeds) {
      commit('setBreeds', objBreeds);
    },
    setUserProfile({
      commit
    }, objUserProfile) {
      commit('setUserProfile', objUserProfile);
    },
    clearUserProfile({ commit }) {
      commit('clearUserProfile');
    },
    setUserEnabled({ commit }, boolVal) {
      commit('setUserEnabled', boolVal);
    },
    setUploadProgress({
      commit
    }, val) {
      commit('setUploadProgress', val);
    },
    setUploadStatus({
      commit
    }, val) {
      commit('setUploadStatus', val);
    },
    setErrorMsg({
      commit
    }, errorMsg) {
      commit('setErrorMsg', errorMsg);
    },
    resetErrorMsg({
      commit
    }) {
      commit('setErrorMsg', null);
    },
    // setLastAction({
    //   commit
    // }, lastAction) {
    //   commit('setLastAction', lastAction);
    // },
    // resetLastAction({
    //   commit
    // }) {
    //   commit('setLastAction', null);
    // },
    setDocListener({
      commit
    }, payload) {
      commit('setDocListener', payload)
    },
    clearDocListeners({ commit }) {
      commit('clearDocListeners');
    },

    setLoginRdq({
      commit
    }, val) {
      commit('setLoginRdq', val);
    },

    setPageAccess({
      commit
    }, val) {
      commit('setPageAccess', val)
    },

    setJustLoggedIn({
      commit
    }, boolVal) {
      commit('setJustLoggedIn', boolVal)
    },


  },
  mutations: {
    setAppActive(state, boolVal) {
      state.appActive = boolVal;
    },
    setUploadSvcActive(state, boolVal) {
      state.uploadSvcActive = boolVal;
    },
    setContactActive(state, boolVal) {
      state.contactActive = boolVal;
    },

    incNumUploadTrackerChanges(state) {
      state.numUploadTrackerChanges++;
    },
    resetNumUploadTrackerChanges(state) {
      state.numUploadTrackerChanges = 0;
    },
    setUploadInProgress(state, boolVal) {
      state.uploadInProgress = boolVal;
    },
    setUploadCompleted(state, boolVal) {
      state.uploadCompleted = boolVal;
    },
    setBreeds(state, objBreeds) {
      if (objEmpty(objBreeds)) {
        state.breeds = {} // really just for testing: Pass empty obj to clear the breeds property 
      } else {
        state.breeds = {
          ...state.breeds,
          ...objBreeds
        };
      }
    },
    setUserProfile(state, objUserProfile) {
      state.userProfile = {
        ...state.userProfile,
        ...objUserProfile
      };
    },
    clearUserProfile(state) {
      state.userProfile = {};
    },
    setUserEnabled(state, boolVal) {
      state.userEnabled = boolVal;
    },
    setUploadProgress(state, val) {
      state.uploadProgress = val;
    },
    setUploadStatus(state, val) {
      state.uploadStatus = val;
    },
    setLoginRdq(state, val) {
      state.loginRdq = val;
    },

    setPageAccess(state, val) {
      state.pageAccess = val;
    },

    setJustLoggedIn(state, val) {
      val = !!val;
      state.justLoggedIn = val;
    },


    setErrorMsg(state, errorMsg) {
      state.errorMsg = errorMsg;
    },
    // setLastAction(state, lastAction) {
    //   state.lastAction = lastAction;
    // },
    setDocListener(state, payload) {
      state.docListeners = {
        ...state.docListeners,
        ...payload
      }
    },
    clearDocListeners(state) {
      state.docListeners = {}
    }


  },
  modules
})